import { useCallback, useContext, useMemo } from "react";
import get from "lodash-es/get";
import { LangContext } from "../contexts";
import { enTranslations, esTranslations } from "../constants";
export const useTranslation = () => {
    const lang = useContext(LangContext);
    const getTranslateConfig = useCallback((option = "", params = {}) => {
        let str = get(lang.toLocaleLowerCase().startsWith("es")
            ? esTranslations
            : enTranslations, option, "");
        Object.keys(params || {}).forEach(key => {
            const regex = new RegExp(`{{${key}}}`);
            str = str.replace(regex, params[key]);
        });
        return str;
    }, [lang]);
    return useMemo(() => ({
        locale: lang,
        t: getTranslateConfig
    }), [getTranslateConfig, lang]);
};
